import styled from 'styled-components'
import PropTypes from 'prop-types'

import { features } from '@h2/components/media'
import { Flex } from '@h2/components/layout/flex'
import { Skeleton as SkeletonLoader } from '@h2/components/loading/skeleton'
import { Card } from '@h2/common/components/card'

import { Controls } from '../controls'

const Highlight = styled(SkeletonLoader)`
  grid-area: hlt;
  height: 100%;
`
const Wrap = styled(Flex)`
  height: 100%;
  flex-direction: column;

  > div.options {
    flex-direction: column;
  }

  @media (${features.minWidth.laptop}) {
    > div.options {
      flex-direction: row;
    }
  }
`
const SkeletonButton = styled(SkeletonLoader)`
  width: 175px;

  @media (${features.minWidth.laptop}) {
    width: 250px;
  }
`
const Skeleton = ({ inDialog }) => {
  return (
    <Card inDialog={inDialog}>
      <Highlight />
      <Card.Content>
        <Wrap>
          <SkeletonLoader height="32px" margin="0 auto 25px auto" width="70%" />
          <SkeletonLoader height="20px" margin="0 auto 30px auto" width="60%" />
          <Flex gap="15px" className="options">
            <SkeletonLoader height="100px" />
            <SkeletonLoader height="100px" />
          </Flex>
          <Controls>
            <SkeletonLoader width="250px" height="45px" margin="0 0 0 auto" />
          </Controls>
        </Wrap>
      </Card.Content>
      <Card.Detour>
        <SkeletonButton height="45px" margin="0 0 0 auto" />
      </Card.Detour>
    </Card>
  )
}

Skeleton.propTypes = {
  inDialog: PropTypes.bool
}

export { Skeleton }
